interface CookieData {
    cookieId: string;
    emails: string[];
}

export class CookieManager {
    private static readonly COOKIE_NAME = 'clv_uid';
    private static readonly COOKIE_EXPIRY_DAYS = 365;
    private static readonly MAX_EMAILS = 5;


    static generateUUID(): string {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            const r = (Math.random() * 16) | 0;
            const v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }

    static reorderEmails(emails: string[], emailToMove: string): string[] {
        const filteredEmails = emails.filter(e => e !== emailToMove);
        return [emailToMove, ...filteredEmails].slice(0, this.MAX_EMAILS);
    }

    static setCookie(cookieId: string, emails: string[]): void {
        const data: CookieData = {
            cookieId,
            emails
        };

        const expires = new Date();
        expires.setDate(expires.getDate() + this.COOKIE_EXPIRY_DAYS);
        document.cookie = `${this.COOKIE_NAME}=${JSON.stringify(data)};expires=${expires.toUTCString()};path=/;SameSite=Strict`;
    }

    static getCookieData(): CookieData | null {
        const match = document.cookie.match(new RegExp(`(^| )${this.COOKIE_NAME}=([^;]+)`));
        if (!match) return null;
        try {
            return JSON.parse(match[2]);
        } catch {
            return null;
        }
    }
    static getCookieId(): string {
        const data = this.getCookieData();
        if (!data) {
            const cookieId = this.generateUUID();
            this.setCookie(cookieId, []);
            return cookieId;
        }
        return data.cookieId;
    }

    static getEmails(): string[] {
        const data = this.getCookieData();
        return data?.emails || [];
    }

    static addEmail(email: string): void {
        const data = this.getCookieData();
        if (!data) {
            const cookieId = this.generateUUID();
            this.setCookie(cookieId, []);
            return this.addEmail(email);
        }

        const currentEmails = data.emails || [];
        const reorderedEmails = this.reorderEmails(currentEmails, email);
        
        this.setCookie(data.cookieId, reorderedEmails);
    }
}